import { createApp, nextTick } from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import { applyInterceptors } from "./utils/interceptors";
import { authApi, defaultApi } from "./services/axiosInstances";
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import "element-plus/theme-chalk/display.css";
import * as ElementPlusIconsVue from "@element-plus/icons-vue";
import id from "element-plus/es/locale/lang/id";
import dayjs from "dayjs";
import "dayjs/locale/id";

dayjs.locale("id");
const customId = {
	...id,
	el: {
		...id.el,
		datepicker: {
			...id.el.datepicker,
			year: "",
		},
	},
};

applyInterceptors(defaultApi);
applyInterceptors(authApi);

store.dispatch("loadAuth").finally(() => {
	const app = createApp(App);
	app.config.globalProperties.$defaultApi = defaultApi;
	app.config.globalProperties.$authApi = authApi;
	app.config.globalProperties.$ws = {};

	app.use(nextTick);
	app.use(store);
	app.use(router);
	app.use(ElementPlus, { locale: customId });
	for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
		app.component(key, component);
	}

	app.mount("#app");
});
